import axios, { endpoints } from 'src/utils/axios';

import { STORAGE_KEY } from './constant';
import { POLICY } from 'src/utils/constants';

// ----------------------------------------------------------------------

export function jwtDecode(token) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

export function initRefreshToken(expiresAt) {
  setTimeout(async () => {
    try {
      new Promise((resolve, reject) => {
        axios
          .post(`${endpoints.auth.refreshToken}`, null, {
            withCredentials: true,
            mode: 'cors',
            headers: {
              Accept: 'text/plain',
            },
          })
          .then((res) => {
            const accessToken = res.data;

            if (!accessToken) {
              throw new Error('Access token not found in response');
            }

            setSession(accessToken);
            resolve(true);
          })
          .catch((e) => {
            reject(e);
          });
      });
    } catch (error) {
      throw error;
    }
  }, expiresAt - Date.now());
}

// ----------------------------------------------------------------------

export async function setSession(accessToken) {
  try {
    if (accessToken) {
      const expiresAt = getTokenExpiration(accessToken);
      localStorage.setItem(STORAGE_KEY, accessToken);

      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

      initRefreshToken(expiresAt);
    } else {
      localStorage.removeItem(STORAGE_KEY);
      delete axios.defaults.headers.common.Authorization;
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}

function getTokenExpiration(token) {
  const payload = JSON.parse(atob(token.split('.')[1]));
  return payload.exp * 1000;
}

export const getDecodedToken = () => {
  const accessToken = localStorage.getItem(STORAGE_KEY);
  return jwtDecode(accessToken);
};

export const hasUserAccess = (policies) => {
  const accessToken = localStorage.getItem(STORAGE_KEY);
  const decodedToken = jwtDecode(accessToken);

  if (!policies || !policies?.length) {
    return true;
  }

  return decodedToken?.policies?.includes(POLICY.ALL)
    ? true
    : policies?.some((role) =>
        decodedToken?.policies
          ?.trim()
          ?.split(',')
          ?.some((r) => r === role)
      );
};
